import moment from "moment";
import { importUpdateCashflowNeeded, importUpdateNeeded } from "../../../../redux/actions/flujocaja";
import { importAlertState } from "../../../../redux/actions/alert";
import { moneyToNumber } from "../../../../utils/formatter";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));


export const sendSubmitForm = async (
  e,
  data,
  dispatch,
  postInitialBalance,
  closeMenu,
  companyId,
  postManualDocument,
  getDate,
  getEndDate,
  credit,
  createCreditsDocument,
  getCreditDate,
  getCreditEndDate
) => {
  e.preventDefault();
  if (
    data.name &&
    data.entryType &&
    data.comment &&
    data.entryType === "initialBalance" &&
    data.amount
  ) {
    const result = await postInitialBalance({
      amount: moneyToNumber(data?.amount),
      documentDate: moment().toDate(),
      companyId: companyId,
      name: data?.name,
      description: data?.comment,
      currencyType: data?.currency,
    });
    if (result.data) {
      dispatch(
        importAlertState({
          state: "success",
          duration: 5,
          content: "Fuente creada correctamente",
        })
      );
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      closeMenu();
    }
    if (result.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
      closeMenu();
    }
  } else if (
    data.name &&
    data.entryType &&
    data.comment &&
    data.entryType === "singleEntry" &&
    data.amount &&
    data.date &&
    data.area
  ) {
    const result = await postManualDocument({
      amount: moneyToNumber(data?.amount),
      documentDate: getDate,
      companyId: companyId,
      cashflowAreaId: data?.area,
      meta: {
        repeating: false,
      },
      name: data?.name,
      description: data?.comment,
      currencyType: data?.currency,
    });
    if (result.data) {
      dispatch(
        importAlertState({
          state: "success",
          duration: 5,
          content: "Fuente creada correctamente",
        })
      );
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      closeMenu();
    }
    if (result.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
      closeMenu();
    }
  } else if (
    data.name &&
    data.entryType &&
    data.comment &&
    data.entryType === "recurrent" &&
    data.amount &&
    data.date &&
    data.area &&
    data.repeat &&
    data.finalDate
  ) {
    const result = await postManualDocument({
      amount: moneyToNumber(data?.amount),
      documentDate: getDate,
      companyId: companyId,
      cashflowAreaId: data?.area,
      meta: {
        interval: parseFloat(data.repeat),
        repeating: true,
        until: getEndDate,
        pago: data?.pay,
      },
      name: data?.name,
      description: data?.comment,
      currencyType: data?.currency,
    });
    if (result.data) {
      dispatch(
        importAlertState({
          state: "success",
          duration: 5,
          content: "Fuente creada correctamente",
        })
      );
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      closeMenu();
    }
    if (result.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
      closeMenu();
    }
  } else if (
    data.name &&
    data.entryType &&
    data.comment &&
    data.entryType === "credits" &&
    credit.id &&
    credit.liquidAmount &&
    credit.paymentsAmount &&
    credit.payments &&
    credit.finalDate &&
    credit.firstDate
  ) {
    const result = await createCreditsDocument({
      companyId: companyId,
      credit: {
        creditType: credit?.creditType,
        bankId: credit?.bank,
        identificator: credit?.id,
        paymentsAmount: moneyToNumber(credit?.paymentsAmount),
        payments: parseFloat(credit?.payments),
        fees: credit?.fees
          ? parseFloat(credit?.fees.replace("%", ""))
          : credit.fees,
        feesPeriod: credit?.feesPeriod,
        totalAmount: moneyToNumber(credit.liquidAmount),
        emision: getCreditDate,
        firstPaymentDate: getCreditEndDate,
        currency: credit?.currency,
      },
    });
    if (result.data) {
      dispatch(
        importAlertState({
          state: "success",
          duration: 5,
          content: "Fuente creada correctamente",
        })
      );
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      closeMenu();
    }
    if (result.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
      closeMenu();
    }
  } else {
    dispatch(
      importAlertState({
        state: "error",
        duration: 3,
        content: "Debe llenar todos los campos del formulario.",
      })
    );
  }
};

export const sendUpdateForm = async (
  value,
  setLoading,
  data,
  dispatch,
  updateManualDocument,
  manualDocumentInfo,
  companyId,
  closeMenu,
  getEndDate,
  deleteManualDocument
) => {
  value.preventDefault();
  setLoading(true);
  if (value.target.outerText === "Guardar Cambios") {
    if (data.entryType === "singleEntry") {
      if (
        !data.name ||
        !data.entryType ||
        !data.comment ||
        !data.amount ||
        !data.date ||
        !data.area
      ) {
        dispatch(
          importAlertState({
            content: "Por favor llene todos los campos del formulario",
            state: "error",
            duration: 3,
          })
        );
        setLoading(false);
      } else {
        dispatch(
          importAlertState({
            content: "Estamos actualizando sus datos, por favor espere",
            state: "loading",
            duration: 10,
          })
        );
        const result = await updateManualDocument({
          id: manualDocumentInfo?.selected[0].documentId,
          input: {
            amount: moneyToNumber(data.amount),
            cashflowAreaId: data.area,
            companyId,
            currencyType: "CLP",
            description: data.comment,
            documentDate: moment(data.date).toDate(),
            documentType: "MANUAL",
            isManual: true,
            meta: { repeating: false },
            name: data.name,
          },
        });
        if (result.data) {
          dispatch(
            importAlertState({
              content: "Datos actualizados correctamente",
              state: "success",
              duration: 3,
            })
          );          
          dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
          setLoading(false);
          closeMenu();
        }
        if (result.error) {
          dispatch(
            importAlertState({
              content:
                "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
              state: "error",
              duration: 5,
            })
          );
          setLoading(false);
          closeMenu();
        }
      }
    } else if (data.entryType === "recurrent") {
      if (
        !data.name ||
        !data.entryType ||
        !data.comment ||
        !data.amount ||
        !data.date ||
        !data.area ||
        !data.repeat ||
        !data.finalDate
      ) {
        dispatch(
          importAlertState({
            content: "Por favor llene todos los campos del formulario",
            state: "error",
            duration: 3,
          })
        );
        setLoading(false);
      } else {
        dispatch(
          importAlertState({
            content: "Estamos actualizando sus datos, por favor espere",
            state: "loading",
            duration: 10,
          })
        );
        const result = await updateManualDocument({
          id: manualDocumentInfo?.selected[0].documentId,
          input: {
            amount: moneyToNumber(data.amount),
            cashflowAreaId: data.area,
            companyId,
            currencyType: "CLP",
            description: data.comment,
            documentDate: moment(data.date).toDate(),
            documentType: "MANUAL",
            isManual: true,
            meta: {
              interval: parseFloat(data.repeat),
              repeating: true,
              until: getEndDate,
              pago: data?.pay,
            },
            name: data.name,
          },
        });
        if (result.data) {
          dispatch(
            importAlertState({
              content: "Datos actualizados correctamente",
              state: "success",
              duration: 3,
            })
          );
          dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
          setLoading(false);
          closeMenu();
        }
        if (result.error) {
          dispatch(
            importAlertState({
              content:
                "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
              state: "error",
              duration: 5,
            })
          );
          setLoading(false);
          closeMenu();
        }
      }
    }
  } else {
    dispatch(
      importAlertState({
        content: "Estamos actualizando sus datos, por favor espere",
        state: "loading",
        duration: 10,
      })
    );
    const result = await deleteManualDocument({
      companyId,
      input: {
        id: manualDocumentInfo?.selected[0].documentId,
        recurringId: null
      }
    });
    if (result.data) {
      dispatch(
        importAlertState({
          content: "Fuente de datos eliminada",
          state: "success",
          duration: 3,
        })
      );
      dispatch(importUpdateNeeded({ value: true }));
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      setLoading(false);
      closeMenu();
    }
    if (result.error) {
      dispatch(
        importAlertState({
          content:
            "Ha ocurrido un error en la operación, por favor vuelva a intentarlo más tarde",
          state: "error",
          duration: 5,
        })
      );
      setLoading(false);
      closeMenu();
    }
  }
};
